import {RolesPage} from "@components/roles/pages/RolesPage.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useContextMenu} from "@contexts/hooks/useContextMenu.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import React, {useCallback} from "react";

export function useUsuarioMenu() {
    const {addPopUp} = useAlert()
    const {setContextOptions} = useContextMenu()

    const rolesOption = useCallback((usuario: IUsuario) => {
        return ({
            label: 'Roles associadas',
            onClick: () => {
                addPopUp({
                    title: `Roles associadas ao usuario ${usuario.id} ${usuario.nome}`,
                    content: <RolesPage filters={{membroId: [usuario.id]}}/>,
                    size: 'xl'
                })
            }
        })
    }, [])

    /**
     * Contexto com roles
     * @param {React.MouseEvent<HTMLElement>} e
     * @param {IUsuario} usuario
     */
    const userContextMenu = (e: React.MouseEvent<HTMLElement>, usuario: IUsuario) => {
        setContextOptions({
            anchor: e.currentTarget,
            event: e,
            options: [rolesOption(usuario)]
        })
    }

    return {
        userContextMenu: userContextMenu
    }
}